import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";
import moment from 'moment';
import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";



export default class AffirmationFilterModel implements IFilterModel {
    search: string = '';
    dateFrom: Date = null;
    dateTo: Date = null;
    isPaid: boolean = null;
    resetToDefault() {
        this.search = '';
        this.dateFrom = null;
        this.dateTo = null;
        this.isPaid = null;
    }
    toSearchRequest(): SearchRequest[] {        
        const res = new Array<SearchRequest>();
        this.isPaid != null && res.push(new SearchRequest({FieldName: 'IsPaid', SearchValue: this.isPaid.toString()}));
        if (this.dateFrom) {
            const range = new SearchRequest({FieldName: 'Created', SearchFrom: moment(this.dateFrom).format('YYYY-MM-DD')});
                res.push(range);
                if (this.dateTo) {
                    range.SearchTo = moment(this.dateTo).format('YYYY-MM-DD');
                }
            }
        return res;
    }
    toFilterRequest(): SearchFilterRequest {
        const res = new SearchFilterRequest({
            Name: this.search
        });
        res.Search = this.toSearchRequest();
        return res;
    }
}